import React from 'react';

interface NmToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
}

/** Neumorphic toggle switch with animated thumb. */
export function NmToggle({ checked, onChange, label, disabled = false }: NmToggleProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--sp-3)',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <label className="nm-toggle">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
        <span className="nm-toggle-track" />
        <span className="nm-toggle-thumb" />
      </label>
      {label && <span style={{ fontSize: 'var(--fs-body)', color: 'var(--fg-2)' }}>{label}</span>}
    </div>
  );
}
